import { useEffect } from 'react';
import { interactiveExperienceCompletedRef } from './interactiveExperienceCompletedRef.tsx';
import { UniversalCreateButtonInteractiveExperience } from './UniversalCreateButtonInteractiveExperience.tsx';

const INTERACTIVE_TIMEOUT_MS = 3000; // 3 seconds

export const useUniversalCreateButtonInteractiveExperienceStart = (): void => {
	// Start tracking interactive experience on component mount
	useEffect(() => {
		UniversalCreateButtonInteractiveExperience.start();

		// Mark as failure if items don't load within timeout
		const timeoutId = setTimeout(() => {
			if (!interactiveExperienceCompletedRef.current) {
				UniversalCreateButtonInteractiveExperience.failure();
				interactiveExperienceCompletedRef.current = true;
			}
		}, INTERACTIVE_TIMEOUT_MS);

		// Cleanup timeout on unmount
		return () => clearTimeout(timeoutId);
	}, []);
};
